import { render } from "./RecommendReport.vue?vue&type=template&id=7dfbd867&scoped=true"
import script from "./RecommendReport.vue?vue&type=script&lang=js"
export * from "./RecommendReport.vue?vue&type=script&lang=js"

import "./RecommendReport.vue?vue&type=style&index=0&id=7dfbd867&scoped=true&lang=css"

import exportComponent from "/home/burton/workspace_skttu/skttu-vote-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfbd867"]])

export default __exports__